module.exports = __webpack_public_path__ + "static/media/recover-pass-success-icon.328e8227.png";